// extracted by mini-css-extract-plugin
export default {"root":"rUxoJHQZ","button":"RB6iLqUz","links":"VMNtqL1i","wrapper":"BSXmWpNN","link":"PJMBRzbp"};